import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { IonicModule } from '@ionic/angular';

import { VendorChatExplainerModalPage } from './vendor-chat-explainer-modal.page';

@NgModule({
  declarations: [VendorChatExplainerModalPage],
  imports: [CommonModule, IonicModule, TranslateModule.forChild()],
  exports: [VendorChatExplainerModalPage],
})
export class VendorChatExplainerModalPageModule {}
